import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// --------------------------PDF-------------------------------------------------------

// generation des emargements
export const generateEmergement = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/pdf/generate-liste-emergement`,
    payload,
    {
      headers: setHeaders(context),

      responseType: "blob",
    },
  );
  return response.data;
};

// generation d'un certicat de frequentation
export const generateFrequentation = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/pdf/generate-certificat-frequentation`,
    payload,
    {
      headers: setHeaders(context),

      responseType: "blob",
    },
  );
  return response.data;
};

// generation de l'emargement journalier
export const generateEmergementJournalier = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/pdf/generate-dailyAttendanceSheet`,
    payload,
    {
      headers: setHeaders(context),

      responseType: "blob",
    },
  );
  return response.data;
};
